"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionModal = void 0;
var react_1 = __importDefault(require("react"));
var react_device_detect_1 = require("react-device-detect");
var react_modal_1 = __importDefault(require("react-modal"));
var spinner_1 = __importDefault(require("../components/spinner"));
var use_theme_1 = __importDefault(require("../hooks/use-theme"));
var use_celo_1 = require("../use-celo");
var colors_1 = require("../utils/colors");
var helpers_1 = require("../utils/helpers");
var tailwind_1 = __importDefault(require("../utils/tailwind"));
var connect_1 = require("./connect");
var styles = (0, tailwind_1.default)(Object.assign(Object.assign({}, connect_1.styles), {
  actionModalContainer: "\n    tw-px-5\n    tw-py-6",
  actionTitle: "\n    tw-text-xl\n    tw-text-center\n    tw-mb-4",
  dappName: "",
  actionDescription: "\n    tw-text-sm\n    tw-text-center",
  actionSpinnerContainer: "\n    tw-my-8\n    tw-flex\n    tw-items-center\n    tw-justify-center",
  contentContainer: "\n    tw-max-h-screen\n  ",
  content: "\n    tw-relative\n    tw-w-80\n    md:tw-w-96\n    ".concat(react_device_detect_1.isMobile ? "\n      tw-flex\n      tw-flex-col\n      tw-justify-center\n      tw-self-center\n      tw-h-screen\n      tw-mx-auto\n    " : '', "\n  ")
}));
var DefaultActionModalComponent = function DefaultActionModalComponent(_ref) {
  var dappName = _ref.dappName,
    pendingActionCount = _ref.pendingActionCount,
    theme = _ref.theme;
  return react_1.default.createElement("div", {
    className: styles.actionModalContainer,
    style: {
      color: theme.text
    }
  }, react_1.default.createElement("div", {
    className: styles.actionTitle
  }, "Check your wallet"), react_1.default.createElement("p", {
    className: styles.actionDescription
  }, react_1.default.createElement("strong", {
    style: {
      color: theme.primary
    }
  }, dappName), " is trying to", ' ', pendingActionCount > 1 ? "perform ".concat(pendingActionCount, " actions") : 'perform an action', ". Please check your wallet to confirm."), react_1.default.createElement("div", {
    className: styles.actionSpinnerContainer
  }, react_1.default.createElement(spinner_1.default, null)));
};
var ActionModal = function ActionModal(_ref2) {
  var reactModalProps = _ref2.reactModalProps,
    _ref2$render = _ref2.render,
    render = _ref2$render === void 0 ? DefaultActionModalComponent : _ref2$render;
  var theme = (0, use_theme_1.default)();
  var _ref3 = (0, use_celo_1.useCeloInternal)(),
    pendingActionCount = _ref3.pendingActionCount,
    dapp = _ref3.dapp;
  (0, helpers_1.useFixedBody)(pendingActionCount > 0);
  return react_1.default.createElement(react_modal_1.default, Object.assign({
    portalClassName: styles.portal,
    htmlOpenClassName: 'react-celo-modal-open-html',
    bodyOpenClassName: 'react-celo-modal-open-body',
    isOpen: pendingActionCount > 0,
    // isOpen
    ariaHideApp: false,
    style: {
      content: {
        background: theme.background
      },
      overlay: {
        background: (0, colors_1.hexToRGB)(theme.background, 0.8)
      }
    }
  }, reactModalProps ? reactModalProps : {
    className: styles.modal,
    overlayClassName: styles.overlay
  }), react_1.default.createElement("div", {
    className: "react-celo ".concat(styles.contentContainer)
  }, react_1.default.createElement("div", {
    className: styles.content
  }, render({
    dappName: dapp.name,
    pendingActionCount: pendingActionCount,
    theme: theme
  }))));
};
exports.ActionModal = ActionModal;